// src/modules/reclamos/services/reclamosApi.js
import axios from "../../../config/axiosConfig";

/**
 * API de Reclamos
 * Todos los métodos retornan `data` ya desenvuelto desde axios.
 */
export const reclamosApi = {
  // Listado con filtros (estado, id_responsable | responsable, id_usuario, prioridad, search, page, limit)
  listar: async (params) => {
    const { data } = await axios.get("/api/reclamos", { params });
    return data;
  },

  // Detalle (puede devolver { reclamo, eventos, mensajes } o solo el reclamo)
  getById: async (id) => {
    const { data } = await axios.get(`/api/reclamos/${id}`);
    if (data && !data.reclamo) {
      return { reclamo: data, eventos: [], mensajes: [] };
    }
    return data;
  },

  // Crear reclamo
  crear: async (payload) => {
    const { data } = await axios.post("/api/reclamos", payload);
    return data;
  },

  // Cambiar estado (payload: { estado, id_actor })
  cambiarEstado: async (id, payload) => {
    const { data } = await axios.patch(`/api/reclamos/${id}/estado`, payload);
    return data;
  },

  // Reasignar responsable (payload: { id_responsable, id_actor })
  reasignar: async (id, payload) => {
    const { data } = await axios.patch(`/api/reclamos/${id}/asignar`, payload);
    return data;
  },

  // Agregar mensaje al reclamo
  addMensaje: async (id, payload) => {
    const { data } = await axios.post(`/api/reclamos/${id}/mensajes`, payload);
    return data;
  },

  // Categorías
  categorias: async (params) => {
    const { data } = await axios.get("/api/reclamos-categorias", { params });
    return data;
  },

  // Usuarios TRS (para mapear IDs/nombres en UI)
  usuariosTRS: async (params) => {
    const { data } = await axios.get("/api/usuarios-trs", { params });
    return data;
  },

  /**
   * Reporte: resumen por fechas
   * Espera en backend: GET /api/reclamos/resumen?desde=YYYY-MM-DD&hasta=YYYY-MM-DD
   * Respuesta esperada: { resueltos: number, mantenimiento: number, total: number }
   */
  resumenEstados: async ({ desde, hasta }) => {
    const { data } = await axios.get("/api/reclamos/resumen", {
      params: { desde, hasta },
    });
    return data;
  },
};
